import { useState } from "react";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { Sling as Hamburger } from "hamburger-react";
import NavLinks from "../components/NavLinks";

const NavBar = () => {
  const [isOpen, setOpen] = useState(false);


  const navlinks = [
    { path: "/", name: "Home" },
    { path: "project", name: "Projects" },
    { path: "about", name: "About" },
    { path: "contact", name: "Contact" },
  ];

  return (
    <Nav>
      <div className="nav-container">
        <div className="hacker-text"></div>

        <div className="hamburger">
          <Hamburger toggled={isOpen} toggle={setOpen} />
        </div>
        <div className="menu-items">
          {navlinks.map((e) => (
            <NavLinks item={e} key={e.path} />
          ))}
        </div>

        <AnimatePresence>
          {isOpen && (
            <motion.div
              className="mobile-menu-items"
              initial={{ opacity: 0, x: 200 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 200 }}
              transition={{
                duration: 0.3,
              }}
            >
              <motion.div className="bg"></motion.div>
              {navlinks.map((e) => (
                <NavLinks item={e} key={e.path} />
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </Nav>
  );
};

const Nav = styled(motion.nav)`
  min-height: 6rem;
  position: fixed;
  top: 0;
  z-index: 20;
  width: 100%;
  margin: auto;
  background: linear-gradient(to top, transparent 0%, #0c0c0c 50%);

  .nav-container {
    min-height: 6rem;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: 9rem;
    margin-right: 8rem;
    text-align: start;

    @media (max-width: 900px) {
      justify-content: flex-end;
    }

    .hacker-text {
      @media (max-width: 900px) {
        display: none;
      }
    }

    .menu-items {
      .links {
        color: white;
      }

      .nav-link-active {
        background: #ffffff;
        color: #191919;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.35),
          inset 0px 4px 4px rgba(0, 0, 0, 0.35);
      }
    }

    .menu-items a {
      margin: 0rem 1rem;
      font-family: "Work Sans", sans-serif;
      text-decoration: none;
      font-weight: 600;
      text-align: center;
      padding: 0.2rem 0.8rem;
      border-radius: 0.1rem;

      &:hover {
        /* color: white; */
        color: #191919;
        /* background: linear-gradient(to right, #5b1c7c, #2e3aa3); */
        background: white;
      }

      @media (max-width: 900px) {
        display: none;
      }
    }

    ///////////////////////////////////////

    .mobile-menu-items {
      display: none;
      font-family: "Work Sans", sans-serif;
      font-weight: 600;
      position: absolute;
      top: 0;
      left: 1;
      padding-right: 10rem;
      min-height: 100vh;
      padding: 0;
      padding: 3rem 0rem;

      .bg {
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: linear-gradient(to right, transparent 0%, #0c0c0c 10%);
      }

      a {
        z-index: 100;
        padding: 0.2rem 0.8rem;
        border-radius: 0.1rem;
        text-align: center;
        text-decoration: none;
      }

      .links {
        color: white;
      }

      a:hover {
        background: #ffffff;
        color: #191919;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.35),
          inset 0px 4px 4px rgba(0, 0, 0, 0.35);
      }

      @media (max-width: 900px) {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        text-align: center;
        align-items: center;
        text-align: center;
        width: 70%;
      }
    }

    ///////////////////////////////////////

    .hamburger {
      display: none;
      z-index: 200;

      .hamburger-react {
        color: white;
      }

      @media (max-width: 900px) {
        display: block;
        z-index: 200;
        margin-right: 1rem;
      }
    }

    @media (min-width: 1600px) {
      margin: 0;
      padding: 0rem 8rem;
      margin: auto;
      width: 100rem;
      min-height: 4.5rem;
    }

    @media (max-width: 1300px) {
      margin-left: 4.5rem;
      margin-right: 3rem;
    }

    @media (max-width: 1150px) {
      margin-left: 4.5rem;
      margin-right: 0rem;
    }

    @media (max-width: 600px) {
      min-height: 5rem;
      margin: 0rem 0rem;
    }
  }

  @media (max-width: 900px) {
    background: transparent;
  }
`;

export default NavBar;
